export const GET_DIVISION = 'GET_DIVISION';
export const LOADING_DIVISION = 'LOADING_DIVISION';
export const SAVE_DIVISION_LOADER = 'SAVE_DIVISION_LOADER';
export const FORM_FAIL = "FORM_FAIL";
export const DIVISION_FAIL = 'DIVISION_FAIL';